export const LOCAL_STORAGE_KEY_PREFIX = "campee";
